import { render, staticRenderFns } from "./ImportRbuSectionTemplateDialog.vue?vue&type=template&id=5f95ad16"
import script from "./ImportRbuSectionTemplateDialog.vue?vue&type=script&lang=js"
export * from "./ImportRbuSectionTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportRbuSectionTemplateDialog.vue?vue&type=style&index=0&id=5f95ad16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports